<template>
    <div class="container">
      <div class="logo-container">
        <img src="">
        <h1 style="font-size: 40px">项目展示网站后台管理系统</h1>
        <div style="margin-top: 40px">
          <a-form :form="form" @submit="handleSubmit" >
          <a-row>
          <a-col :span="6" push="9">
          <a-form-item >
            <a-input pressEnter="handleSubmit" allowClear autofocus="autofocus"
              v-decorator="[
            'userName',
            { rules: [{ required: true, message: 'Please input your username!' }] },
          ]"
              placeholder="Username"
            >
              <a-icon slot="prefix" type="user" style="color: rgba(0,0,0,.25)" />
            </a-input>
          </a-form-item>
          </a-col>

          </a-row>
          <a-row>

          <a-col :span="6" push="9">
          <a-form-item >
            <a-input pressEnter="handleSubmit" allowClear
              v-decorator="[
            'password',
            { rules: [{ required: true, message: 'Please input your Password!' }] },
          ]"
              type="password"
              placeholder="Password"
            >
            </a-input>

          </a-form-item>
          </a-col>

          </a-row>
          <a-row>
            <a-col :span="6" push="9">
              <a-form-item>
                <a-button type="primary" html-type="submit"style="width: 100%">登录
                </a-button>
              </a-form-item>
            </a-col>
          </a-row>

      </a-form>
        </div>
      </div>
    </div>
</template>

<script>
    import ARow from "ant-design-vue/es/grid/Row";
    import ACol from "ant-design-vue/es/grid/Col";
    export default {
      name: "Login",
      components: {ACol, ARow},
      beforeCreate() {
        this.form = this.$form.createForm(this, { name: 'normal_login' });
      },
      created (){

      },
      data (){
          return {
            userName:'',
            password:'',
            form,
          }
      },
      methods :{
        handleSubmit (){

        }
      }
    }
</script>

<style scoped>
  .container {
    padding: 200px;
    height: 900px;
    background-image: url('https://gw.alipayobjects.com/zos/rmsportal/TVYTbAXWheQpRcWDaDMu.svg');

  }
  .logo-container{
    text-align: center;

    /*background-color: aquamarine;*/
    /*min-height: 600px;*/
    /*min-width: 1000px;*/
    background-repeat: no-repeat;
    background-position: center 110px;
    background-size: 100%;
    /*padding-top: 200px;*/
    /*padding-left: 438px;*/
  }
</style>



// WEBPACK FOOTER //
// src/pages/Login.vue